const PRASHNA_QUICK_CHIPS = {
  en: [
    { label: "💼 New Job / Promotion", text: "Will I get a new job or career promotion soon?" },
    { label: "💍 Marriage Timing", text: "When will my marriage take place?" },
    { label: "💰 Money Recovery", text: "Will my delayed money or payment be recovered?" },
    { label: "✈️ Travel / Visa", text: "Will my travel or visa application succeed?" },
  ],
  hi: [
    { label: "💼 नई नौकरी", text: "क्या मुझे जल्द नई नौकरी या प्रमोशन मिलेगा?" },
    { label: "💍 विवाह समय", text: "मेरा विवाह कब तक संपन्न होगा?" },
    { label: "💰 रुका हुआ धन", text: "क्या मेरा रुका हुआ धन वापस मिलेगा?" },
    { label: "✈️ यात्रा / वीज़ा", text: "क्या मेरी यात्रा या वीज़ा सफल होगा?" },
  ],
} as const;

export default function PrashnaQuickQuestions({
  locale,
  questionLabel,
  onSelect,
}: {
  locale: "en" | "hi";
  questionLabel: string;
  onSelect: (text: string) => void;
}) {
  return (
    <>
      <div className="mb-2 flex flex-wrap items-center justify-between gap-1.5">
        <label
          className="block text-body-small font-semibold text-text-primary"
          htmlFor="prashna-question"
        >
          {questionLabel}
        </label>
        <span className="text-caption text-text-muted">
          {locale === "hi" ? "त्वरित विषय चुनें:" : "Quick questions:"}
        </span>
      </div>
      <div className="mb-2.5 flex flex-wrap gap-1.5">
        {PRASHNA_QUICK_CHIPS[locale].map((chip) => (
          <button
            key={chip.label}
            type="button"
            onClick={() => onSelect(chip.text)}
            className="rounded-full border border-border-subtle bg-surface-raised px-2.5 py-1 text-caption font-medium text-text-secondary transition hover:border-border-interactive hover:bg-surface-pressed hover:text-text-primary active:scale-95"
          >
            {chip.label}
          </button>
        ))}
      </div>
    </>
  );
}
